import page from "./_MainPage/_MainPage";

import { actions, reducer } from "./ducks";
import saga from "./saga";

import { Feature } from "features/interfaces";

export const mainFeature: Feature<typeof actions> = {
  reducer,
  saga,
  actions,
  page
};
